<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->
    
    <!-- ノートの内訳 -->
    <transition name="popup">
      <PCContractNoteBreakdown
        v-if="state.visibleNoteBreakdown"
        @closeNoteBreakdown="state.visibleNoteBreakdown = false"
      />
    </transition>

    <div id="wrapper">
      <PCContractHeader />

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->
      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 16px);"
        >
        <div class="contract" id="scroll-target"
          @scroll="handleScroll"
          >
          <div class="contract-head">
            <h1 class="hdg03">契約情報</h1>
          </div>
          <form action="" method="post" class="contract-container">
            <div class="contract-content">
              <p class="txt">契約情報をご確認いただけます。契約情報の変更はお問い合わせフォームにてお申し出ください。</p>
              <h2 class="hdg03">契約情報</h2>
              <div class="column gutter">
                <div class="column-item col-6 space-gutter">
                  <ul class="contract-content-list">
                    <li class="contract-content-list-item">
                      <table class="contract-content-table">
                        <colgroup>
                          <col style="width:50%;">
                          <col sytle="width:50%;">
                        </colgroup>
                        <tbody>
                          <tr v-if="contract.no">
                            <th class="border-none">お客様番号</th>
                            <td class="border-none">{{contract.no}}</td>
                          </tr>
                          <tr v-if="contract.name">
                            <th class="border-none">法人名/個人名</th>
                            <td class="border-none">{{contract.name}}</td>
                          </tr>
                          <tr v-if="contract.kana">
                            <th class="border-none">読み仮名</th>
                            <td class="border-none">{{contract.kana}}</td>
                          </tr>
                          <tr v-if="contract.charge_name">
                            <th class="border-none">ご担当者名</th>
                            <td class="border-none">{{contract.charge_name}}</td>
                          </tr>
                          <tr v-if="contract.department">
                            <th class="border-none">ご担当部署名</th>
                            <td class="border-none">{{contract.department}}</td>
                          </tr>
                          <tr v-if="postnumberAddHyphen || addressUnion || contract.address4">
                            <th class="border-none">郵便番号/住所</th>
                            <td class="border-none">
                              <template v-if="postnumberAddHyphen">〒 {{postnumberAddHyphen}}<br></template>
                              <template v-if="addressUnion">{{addressUnion}}<br></template>
                              <template v-if="contract.address4">{{contract.address4}}</template>
                            </td>
                          </tr>
                          <tr v-if="contract.email">
                            <th class="border-none">メールアドレス</th>
                            <td class="border-none">{{contract.email}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </li>
                  </ul>
                </div>
                <div class="column-item col-6 space-gutter">
                  <ul class="contract-content-list">
                    <li class="contract-content-list-item">
                      <table class="contract-content-table">
                        <colgroup>
                          <col style="width:50%;">
                          <col sytle="width:50%;">
                        </colgroup>
                        <tbody>
                          <tr v-if="contract.job_type_classification || contract.job_type_name">
                            <th class="border-none">職業</th>
                            <td class="border-none">
                              <template v-if="contract.job_type_classification">{{contract.job_type_classification}}</template>
                              <br v-if="contract.job_type_classification && contract.job_type_name">
                              <template v-if="contract.job_type_name">{{contract.job_type_name}}</template>
                            </td>
                          </tr>
                          <tr v-if="contract.tel1">
                            <th class="border-none">電話番号1</th>
                            <td class="border-none">{{contract.tel1}}</td>
                          </tr>
                          <tr v-if="contract.tel2">
                            <th class="border-none">電話番号2</th>
                            <td class="border-none">{{contract.tel2}}</td>
                          </tr>
                          <tr v-if="contract.extension">
                            <th class="border-none">内線番号</th>
                            <td class="border-none">{{contract.extension}}</td>
                          </tr>
                          <tr v-if="contract.fax">
                            <th class="border-none">FAX番号</th>
                            <td class="border-none">{{contract.fax}}</td>
                          </tr>
                          <tr v-if="contract.account_number || contract.account_number_max">
                            <th class="border-none">アカウントの数</th>
                            <td class="border-none">{{contract.account_number}}/{{contract.account_number_max}}</td>
                          </tr>
                          <tr v-if="contract.license_number || contract.license_number_max">
                            <th class="border-none">ライセンスの数</th>
                            <td class="border-none">{{contract.license_number}}/{{contract.license_number_max}}</td>
                          </tr>
                          <tr v-if="contract.note_number || contract.note_number_max">
                            <th class="border-none"><span class="txt-blue ga-admin-note-count" @click="state.visibleNoteBreakdown = true" role="button">ノートの数</span></th>
                            <td class="border-none">{{contract.note_number}}/{{contract.note_number_max}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </li>
                  </ul>
                </div>
              </div>
              <template v-if="isAgreement">
                <!-- 既定のお支払い方法 -->
                <ContractAccountPaymentMethod
                  :parentName="'PCContract'"
                />
              </template>

            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import PCContractHeader from '@/components/pc/partial/contract/ContractHeader.vue'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCContractNoteBreakdown from '@/components/pc/popup/PCContractNoteBreakdown.vue'
import Vue from 'vue'
import router from '@/router'

import ContractAccountPaymentMethod from '@/components/pc/partial/contract/ContractAccountPaymentMethod.vue'

import { Contract } from '@/logic/contract/Contract'

export default defineComponent({
  components: {
    PCContractHeader,
    PCMenu,
    PCContractNoteBreakdown,
    ContractAccountPaymentMethod
  },
  setup (props, context) {
    return {
      ...Contract(context)
    }
  }
})
</script>

<style lang="scss" scoped>
#header {
  @media screen and (max-width: 1250px) {
    .header-search-tab {
      position: relative;
      &-02 {
        position: absolute;
        top: 52px;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px rgba(0,0,0,.16);
        .header-search-tab-item {
          height: 48px;
          padding: 0 10px;
          a {
            color: $color-link;
            padding: 2px 10px;
            font-size: 1.4rem;
          }
        }
      }
    }
  }
}
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.contract {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0 150px;
  }
  &-head {
    padding: 30px 40px 25px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    &-list {
      list-style: none;
      &-item {
        border-top: 1px solid $color-line;
        padding: 20px 0 0;
      }
    }
    .txt {
      line-height: 1.625;
    }
    .hdg03{
      margin: 62px 0 15px;
    }
    &-table {
      width: 100%;
      border-collapse: collapse;
      .border-none {
        border: 0!important;
      }
      &.border-bottom {
        border-bottom: 1px solid $color-line;
      }
      thead {
        th {
          color: $color-sup;
          font-size: 1.6rem;
          font-weight: normal;
          padding: 10px 15px 10px 0;
        }
      }
      tbody {
        th,td {
          vertical-align: top;
          padding: 10px 15px 10px 0;
          border-top: 1px solid $color-line;
          font-size: 1.6rem;
          line-height: 1.625;
          text-align: left;
        }
        th {
          color: $color-hdg;
        }
      }
      &-link {
        font-size: 1.6rem;
        color: $color-link;
      }
    }
  }
  &-submit {
    width: 230px;
    margin: 0 auto;
  }
}
</style>
